// Public API for compiler
export {ComponentResolver} from './linker/component_resolver';
export {SystemJsComponentResolver} from './linker/systemjs_component_resolver';
export {QueryList} from './linker/query_list';
export {DynamicComponentLoader} from './linker/dynamic_component_loader';
export {ElementRef} from './linker/element_ref';
export {TemplateRef} from './linker/template_ref';
export {EmbeddedViewRef, ViewRef} from './linker/view_ref';
export {ViewContainerRef} from './linker/view_container_ref';
export {ComponentRef, ComponentFactory} from './linker/component_factory';
export {ExpressionChangedAfterItHasBeenCheckedException} from './linker/exceptions';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
